import styled from "styled-components";

export const EndStatusChange = styled.div`
  height: 100%;
  .status-data {
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: calc(100% - 83px);
    padding: 20px;
    box-sizing: border-box;
  }
  .status-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &__icon {
      color: #8A8AC3;
      margin-right: 10px;
    }
    &__text {
      font-family: Nunito Sans;
      font-size: 17px;
      color: #707582;
    }
  }
  .status-field {
    margin-bottom: 20px;
    &__label {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-family: "Nunito Sans";
      font-size: 17px;
    }
    &__text {
      color: #1F1F52;
      font-family: Nunito Sans;
      margin-right: 10px;
    }
    &__required {
      width: 7px;
      color: #FF5757;
    }
    &__icon {
      color: #1F1F52;
      font-size: 7px;
    }
    .input-container {
      border: none;
      border-bottom: 1px solid #6C6BCC;
    } 
  }
  .status-changed {
    border-bottom: 1px solid #CFD3DD;
    padding: 20px;
    display: flex;
    align-items: center;
    &__item {
      display: flex;
      align-items: center;
    }
    &__info {
      /* display: flex; */
      /* flex-direction: column; */
      align-items: center;
    }
    &__label {
      display: flex;
      align-items: center;
      &-icon {
        color: #8A8AC3;
        font-size: 15px;
        margin-right: 7.5px;
        &--new {
          color: #27AE60;
        }
      }
      &-text {
        font-family: Nunito Sans Bold;
        font-size: 14px;
        color: #707582; 
      }
    }
    &__status-name {
      color: #1F1F52;
      font-family: Nunito Sans;
      font-size: 17px;
      &--new {
        background-color: #8AFCC1;
        width: fit-content;
      }
    }
    &__tooltip-info {
      &-icon {
        font-size: 16px;
        margin-left: 5px;
        color: #8A8AC3;
      }
    }
    &__tooltip-icon {
      font-size: 20px;
      margin: 0 20px;
      color: #3E3E5B;
      opacity: 0.4;
    }
  }
`